let watchTime = ''
import { ENV_CONFIG } from '@/config';
if (!ENV_CONFIG.X_CA_STAGE) {
  watchTime = `wss://${ENV_CONFIG.BAPI_API_DOMAIN}/v1/stats/channel/watchTime`
} else if (ENV_CONFIG.X_CA_STAGE === 'PRE') {
  watchTime = `wss://${ENV_CONFIG.BAPI_API_DOMAIN}/v1/stats/channel/watchTime`
} else if (ENV_CONFIG.X_CA_STAGE === 'TEST') {
  watchTime = `wss://${ENV_CONFIG.BAPI_API_DOMAIN}/v1/stats/channel/watchTime`
}

export {watchTime}
